import { getApiEndpoint } from "../utils/constants/api";
import { SHOP_SOURCES } from "../utils/constants/shopSources";
import { wfetch } from "../utils/fetch";
import { getCategories, getCategoryTreeIds } from "./categories.service";

export const getProducts = async (opts) => {
    const { source, category, queryParams } = opts;

    // JCR source
    if (source === SHOP_SOURCES.JCR) {
        const { lang } = opts;

        const res = await wfetch(getApiEndpoint("PRODUCTS", { queryParams: { lang, ...queryParams } }));
        let products = res?.data?.results;

        if (!category) return products;

        const categoryIds = getCategoryTreeIds(category);

        return filterProductsByCategoryIds(products, categoryIds, source);
    }

    // External sources
    const res = await wfetch(
        getApiEndpoint("EXTERNAL_PRODUCTS", {
            pathParams: { source, categoryId: encodeURIComponent(category?.["@id"]) },
            queryParams: { limit: 9999, ...queryParams },
        }),
    );

    return res?.data?.results;
};

export const getProduct = async (opts) => {
    const { source, productId } = opts;

    // JCR source
    if (source === SHOP_SOURCES.JCR) {
        const { lang } = opts;
        const res = await wfetch(getApiEndpoint("PRODUCTS", { queryParams: { "@path": productId, lang } }));

        return res?.data?.results?.[0];
    }

    // External sources
    const res = await wfetch(getApiEndpoint("EXTERNAL_PRODUCT", { pathParams: { source, productId: encodeURIComponent(productId) } }));

    return res?.data;
};

export const filterProductsByCategoryIds = (products, categoryIds, source) => {
    if (source !== SHOP_SOURCES.JCR) return products;

    return products.filter((p) => Array.isArray(p.category) && p.category.some((c) => categoryIds.has(c["@id"])));
};
